import Glide from '@glidejs/glide'
// import { Dropdown } from 'bootstrap'

const compareSolutionsTable = document.querySelector('.compare-solutions__table')
const compareSolutionsGlideContainer = document.querySelector('.compare-solutions__glide')
const loading = compareSolutionsTable.querySelector('.compare-solutions__table__loading')
const mainLabels = compareSolutionsTable.querySelectorAll(
  '.compare-solutions__table__labels__cols .compare-solutions__table__col'
)
const slideContainer = compareSolutionsTable.querySelector('.glide__slides')
const tablePlaceholder = document.querySelector('.compare-solutions-placeholder')
const tableSlideColumns = compareSolutionsTable.querySelectorAll('.compare-solutions__table__slide')
const accordionHeder = document.querySelectorAll('.compare-solutions__table__accordion-header')
const compareButton = document.querySelector('.compare-solutions-btn')
const dropdown = document.querySelector('.compare-solutions__table__dropdown .dropdown-toggle')
const numOfSolutions = tableSlideColumns.length
const uniqueIds = []
const slideIds = []
let isGlideActive = false
const compareSolutionTableHead = document.querySelector('.compare-solutions__table__labels__head')
const gliderArrows = document.querySelectorAll('.compare-solutions .glide__arrow button')
let isScrolling

const ArrowDisabler = function (Glide, Components, Events) {
  return {
    mount() {
      // Only in effect when rewinding is disabled
      if (Glide.settings.rewind) {
        return
      }

      Glide.on(['mount.after', 'run'], () => {
        // Filter out arrows_control
        for (let controlItem of Components.Controls.items) {
          if (controlItem.className !== 'glide__arrows') {
            continue
          }

          // Set left arrow state
          var left = controlItem.querySelector('.glide__arrow--left')
          if (left) {
            if (Glide.index === 0) {
              left.setAttribute('disabled', '') // Disable on first slide
            } else {
              left.removeAttribute('disabled') // Enable on other slides
            }
          }

          // Set right arrow state
          var right = controlItem.querySelector('.glide__arrow--right')
          if (right) {
            if (Glide.index === Components.Sizes.length - Glide.settings.perView) {
              right.setAttribute('disabled', '') // Disable on last slide
              compareSolutionsTable.classList.add('last-slide')
            } else {
              right.removeAttribute('disabled')
              compareSolutionsTable.classList.remove('last-slide')
            }
          }
        }
      })
    },
  }
}

const showColumns = (columns, glide) => {
  const windowWidth = window.innerWidth
  let perViewItems = 6

  if (windowWidth <= 1200) {
    perViewItems = 4
  }

  if (windowWidth <= 990) {
    perViewItems = 3
  }

  if (windowWidth <= 600) {
    perViewItems = 2
  }

  slideContainer.innerHTML = ''
  columns.forEach((col) => {
    const newCol = tablePlaceholder.querySelector(`[data-slide-id=${col}]`)
    const clone = newCol.cloneNode(true)
    slideContainer.appendChild(clone)
  })
  resizeCols()

  columns.length <= perViewItems
    ? glide.update({ perView: columns.length })
    : glide.update({ perView: perViewItems })
  glide.go('<<')

  if (columns.length === numOfSolutions) {
    dropdown.textContent = 'All DSG solutions'
  } else if (columns.length > 1) {
    dropdown.textContent = `${columns.length} solutions selected`
  } else if (columns.length === 1) {
    dropdown.textContent = `${columns.length} solution selected`
  }
}

const debounce = (cb, delay = 1000) => {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      cb(...args)
    }, delay)
  }
}

const resizeCols = () => {
  uniqueIds.forEach((col) => {
    const colHeights = []
    const uniqueCols = compareSolutionsTable.querySelectorAll(`[data-compare-col="${col}"]`)
    uniqueCols.forEach((uCol) => {
      colHeights.push(uCol.offsetHeight)
    })
    //Set Height
    uniqueCols.forEach((uCol) => {
      uCol.style.height = `${Math.max(...colHeights)}px`
    })
  })
}

console.log(numOfSolutions)

if (compareSolutionsGlideContainer) {
  const cols = compareSolutionsTable.querySelectorAll('.compare-solutions__table__col')

  // tableSlideColumns.forEach((slide) => {
  //   slideIds.push(slide.dataset.slideId)
  //   const clone = slide.cloneNode(true)
  //   tablePlaceholder.appendChild(clone)
  // })

  const compareSolutionsGlide = new Glide(compareSolutionsGlideContainer, {
    type: 'slider',
    gap: 0,
    startAt: 0,
    autoplay: false,
    perView: 6,
    perSwipe: '|',
    peek: {
      before: 16,
      after: 60,
    },
    breakpoints: {
      1200: {
        perView: 4,
      },
      990: {
        perView: 3,
      },
      600: {
        perView: 2,
        peek: {
          before: 0,
          after: 0,
        },
      },
    },
    rewind: false,
    bound: true,
  })

  cols.forEach((col) => {
    const colId = col.dataset.compareCol
    if (!uniqueIds.includes(colId)) {
      uniqueIds.push(colId)
    }
  })

  compareSolutionsGlide.mount({ ArrowDisabler })
  isGlideActive = true

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      resizeCols()
      loading.style.display = 'none'
    }, 2000)
  })

  const heightOnResize = debounce(() => {
    resizeCols()
    console.log('resize')
  }, 1000)

  const observer = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      heightOnResize()
    })
  })

  observer.observe(compareSolutionsGlideContainer)

  const removeActiveClass = () => {
    cols.forEach((col) => {
      col.classList.remove('hover')
    })
  }

  const closeDropdown = () => {
    const dropDownToggle = compareSolutionsTable.querySelector('.dropdown-toggle')
    const menu = compareSolutionsTable.querySelector('.dropdown-menu')

    dropDownToggle.classList.remove('show')
    dropDownToggle.setAttribute('aria-expanded', 'false')
    menu.classList.remove('show')
    menu.setAttribute('style', '')
  }

  document.addEventListener('click', (e) => {
    if (e.target.hasAttribute('data-compare-col')) {
      removeActiveClass()
      compareSolutionsTable
        .querySelectorAll(`[data-compare-col="${e.target.dataset.compareCol}"]`)
        .forEach((item) => {
          item.classList.add('hover')
        })
    } else {
      removeActiveClass()
    }
  })

  accordionHeder.forEach((header) => {
    const targetSection = header.dataset.accordionSection
    header.addEventListener('click', (e) => {
      e.preventDefault()
      header.classList.toggle('section-hidden-active')
      document.querySelectorAll(`[data-compare-section="${targetSection}"]`).forEach((section) => {
        section.classList.toggle('section-hidden')
      })
    })
  })

  const checkBoxes = compareSolutionsTable.querySelectorAll(
    '.compare-solutions__table__dropdown .select-solutions-checkbox'
  )

  const allItemsCheckbox = compareSolutionsTable.querySelector(
    '.compare-solutions__table__dropdown .select-solutions-checkbox.all-solutions'
  )

  const checkBoxesLength = checkBoxes.length

  allItemsCheckbox.addEventListener('change', (e) => {
    checkBoxes.forEach((checkBox) => {
      allItemsCheckbox.checked ? (checkBox.checked = true) : (checkBox.checked = false)
    })
  })

  checkBoxes.forEach((checkBox) => {
    checkBox.addEventListener('change', (e) => {
      const parentLabel = checkBox.parentElement.parentElement

      if(checkBoxesLength !== compareSolutionsTable.querySelectorAll(
        '.compare-solutions__table__dropdown input:checked'
      ).length) {
        allItemsCheckbox.checked = false
      }

      if(checkBoxesLength - 1 === compareSolutionsTable.querySelectorAll(
        '.compare-solutions__table__dropdown input:checked'
      ).length) {
        allItemsCheckbox.checked = true
      }

      if (checkBox.checked) {
        compareSolutionsTable
          .querySelectorAll('.compare-solutions__table__dropdown input:checked')
          .forEach((element) => {
            element.parentElement.parentElement.classList.add('checked')
          })

        // parentLabel.classList.add('checked')
        compareButton.removeAttribute('disabled')
      } else {
        if (
          compareSolutionsTable.querySelectorAll(
            '.compare-solutions__table__dropdown input:checked'
          ).length === 0
        ) {
          compareButton.setAttribute('disabled', 'disabled')
        }
        compareSolutionsTable
          .querySelectorAll('.compare-solutions__table__dropdown input:not(:checked)')
          .forEach((element) => {
            element.parentElement.parentElement.classList.remove('checked')
          })
      }
    })
  })

  compareButton.addEventListener('click', (e) => {
    e.preventDefault()
    const list = []
    document
      .querySelectorAll('.compare-solutions__table__dropdown input:checked')
      .forEach((item) => {
        if (item.name !== 'all') list.push(item.name)
      })
    if (list.length > 0) {
      showColumns(list, compareSolutionsGlide)
    }
    closeDropdown()
  })

  // solutionOverviewTable.onmousemove = (e) => {
  //   let tableOffsetHeight = document.getElementById('compare-solutions-table')
  //   let y = e.layerY;
  //   if(document.documentElement.scrollTop > tableOffsetHeight.offsetTop + tableHead.offsetHeight) {
  //     for (let i = 0; i < tooltips.length; i++) {
  //       tooltips[i].style.opacity = 1;
  //       tooltips[i].style.top = (y - 20 - tooltips[i].offsetHeight) + 'px';
  //     }
  //   } else {
  //     for (let i = 0; i < tooltips.length; i++) {
  //       tooltips[i].style.opacity = 0;
  //     }
  //   }
  // }
  
  document.addEventListener( 'scroll', () => {
    const tooltips = document.querySelectorAll('.dsg-tooltip-solution-title')

    if(document.documentElement.scrollTop > compareSolutionsTable.offsetTop + compareSolutionTableHead.offsetHeight + 50) {

      gliderArrows.forEach((item) => {
        setTimeout( () => {
          item.style.top = compareSolutionTableHead.offsetTop + 25 + 'px'
        }, 500)
      })
      
      compareSolutionTableHead.style.opacity = 0

      for (let i = 0; i < tooltips.length; i++) {
        tooltips[i].style.opacity = 0

        setTimeout( () => {
          tooltips[i].style.top = compareSolutionTableHead.offsetTop + 'px'
          tooltips[i].style.opacity = 1
          compareSolutionTableHead.style.opacity = 1
        },500)
      }
    } else {

      compareSolutionTableHead.style.opacity = 1
      gliderArrows.forEach((item) => {
        item.style.top = '25px'
      })
      for (let i = 0; i < tooltips.length; i++) {
        tooltips[i].style.opacity = 0
        tooltips[i].style.top = 0
      }
    }
  })
}